import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=582ba72c&scoped=true&"
import script from "./GiftCard.vue?vue&type=script&lang=ts&"
export * from "./GiftCard.vue?vue&type=script&lang=ts&"
import style0 from "./GiftCard.vue?vue&type=style&index=0&id=582ba72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582ba72c",
  null
  
)

export default component.exports